module.exports = __webpack_public_path__ + "static/media/is-bankasi.8be0eac0.svg";